import axiosInstance from "../axiosApi/api.js";
import { toast } from "react-toastify";
import router from "../router.js";
import { handleServerError } from "./errors.js";
import { generate_unique_file_names } from "../utils.js";
import { withNotification } from "../utils/withNotification.js";

import {
  ADD_NEW_USER_RATE_ID,
  CHANGE_LOGIN_MODAL_DISPLAY,
  CHANGE_SIGNUP_MODAL_DISPLAY,
  CHANGE_USER_CURRENCY,
  CLEAR_ERRORS,
  GET_ALL_RATED_IDS,
  GET_USER_PROFILE_DATA,
  USER_DATA,
} from "./types";

export const signupAction = (formValues) => {
  return async (dispatch) => {
    try {
      await axiosInstance.post("/users/", formValues);
      dispatch({
        type: CHANGE_SIGNUP_MODAL_DISPLAY,
        payload: "none",
      });
      router.navigate("/after/signup", { replace: true });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const signupArtistAction = (formValues) => {
  return async (dispatch) => {
    try {
      const files = formValues.profile_pic;
      formValues.profile_pic = generate_unique_file_names(
        formValues.profile_pic
      );
      const res = await axiosInstance.post("/users/artists/", formValues);
      await fetch(res.data.pre_signed_url, {
        method: "PUT",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        body: files[0],
      });
      router.navigate("/after/signup", { replace: true });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const loginAction = (formValues) => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.post("/users/token/", formValues);
      axiosInstance.defaults.headers["Authorization"] =
        "Bearer " + res.data.access;
      localStorage.setItem("access_token", res.data.access);
      localStorage.setItem("refresh_token", res.data.refresh);
      dispatch(getCurrentUserData());
      // router.navigate(window.location.pathname, { replace: true });
      const redirectPath = sessionStorage.getItem("postLoginRedirect") || "/";
      sessionStorage.removeItem("postLoginRedirect");
      router.navigate(redirectPath, { replace: true });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const getCurrentUserData = () => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.get("/users/me/");
      dispatch({
        type: USER_DATA,
        payload: res.data,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const logoutAction = () => {
  return async (dispatch) => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    axiosInstance.defaults.headers["Authorization"] = null;
    dispatch({
      type: USER_DATA,
      payload: null,
    });
    window.location.replace("/");
  };
};

export const changeSignupModalDisplay = (state) => {
  return {
    type: CHANGE_SIGNUP_MODAL_DISPLAY,
    payload: state,
  };
};

export const changePasswordAction = (formValues) => {
  return async (dispatch) => {
    try {
      await withNotification({
        promise: axiosInstance.patch("/users/change/password/", formValues),
      });
      dispatch({
        type: CLEAR_ERRORS,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const requestResetPasswordAction = (formValues) => {
  return async (dispatch) => {
    try {
      await withNotification({
        promise: axiosInstance.post(
          "/users/request/reset/password/",
          formValues
        ),
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const resetPasswordAction = (formValues, additionalData) => {
  return async (dispatch) => {
    try {
      const { uid64, token } = additionalData;
      await withNotification({
        promise: axiosInstance.post(
          `/users/reset/password/${uid64}/${token}/`,
          formValues
        ),
      });
      router.navigate("/", { replace: true });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const getUserProfileDataAction = () => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.get("/users/profile/");
      dispatch({
        type: GET_USER_PROFILE_DATA,
        payload: res.data,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const changeUserCurrency = (Currency) => {
  return {
    type: CHANGE_USER_CURRENCY,
    payload: Currency,
  };
};

export const updateUserDataAction = (userData) => {
  return async (dispatch) => {
    try {
      const formData = new FormData();

      // Handle profile_pic file
      if (userData.profile_pic && typeof userData.profile_pic !== "string") {
        formData.append("profile_pic", userData.profile_pic[0]);
      }

      // Append other fields
      const fields = ["first_name", "last_name", "email", "phone_number", "address", "worker_type"];
      fields.forEach((field) => {
        if (userData[field] !== undefined && userData[field] !== null) {
          formData.append(field, userData[field]);
        }
      });

      await withNotification({
        promise: axiosInstance.put("/users/profile/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        }),
      });

      dispatch(getUserProfileDataAction());
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const changeLoginModalDisplayAciton = (payload) => {
  return {
    type: CHANGE_LOGIN_MODAL_DISPLAY,
    payload: payload,
  };
};

export const submitRatingAction = (values) => {
  return async (dispatch) => {
    try {
      const toast_id = toast.loading("Please wait");
      await axiosInstance.post("/users/rating/", values);
      dispatch({
        type: ADD_NEW_USER_RATE_ID,
        payload: values,
      });
      toast.update(toast_id, {
        render: "All is good",
        type: "success",
        isLoading: false,
        autoClose: true,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const getRatedUserIdsAction = () => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.get("/users/rating/");
      dispatch({
        type: GET_ALL_RATED_IDS,
        payload: res.data,
      });
    } catch (e) {
      handleServerError(dispatch, e);
    }
  };
};

export const requestOTPAction = (phone_number) => {
  return async (dispatch) => {
    try {
      await axiosInstance.post("/users/otp/request/", { phone_number });
      return { success: true };
    } catch (e) {
      // Don't show toast for rate limiting errors
      if (e.response?.status !== 429) {
        handleServerError(dispatch, e);
      }
      return {
        success: false,
        error: e.response?.data?.error || "Failed to send OTP",
        seconds_remaining: e.response?.data?.seconds_remaining,
      };
    }
  };
};

export const verifyOTPAction = (phone_number, code) => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.post("/users/otp/verify/", { phone_number, code });
      axiosInstance.defaults.headers["Authorization"] =
        "Bearer " + res.data.access;
      localStorage.setItem("access_token", res.data.access);
      localStorage.setItem("refresh_token", res.data.refresh);
      dispatch(getCurrentUserData());
      const redirectPath = sessionStorage.getItem("postLoginRedirect") || "/";
      sessionStorage.removeItem("postLoginRedirect");
      router.navigate(redirectPath, { replace: true });
      return { success: true };
    } catch (e) {
      handleServerError(dispatch, e);
      return { success: false, error: e.response?.data?.error || "Invalid OTP" };
    }
  };
};
